module.exports = __webpack_public_path__ + "static/img/venue-map.7b5e144.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/venue-map.jpg
 ** module id = 66
 ** module chunks = 2
 **/